module.exports = __webpack_public_path__ + "static/media/purple_child.b66ec452.jpg";